import React from "react";
import { CONTRACT_ADDRESS, BUY_URL, X_URL, MASCOT_IMG } from "../../data/constants";

export const Footer = () => {
  return (
    <footer className="relative mt-10 border-t-4 border-[#b026ff]" data-testid="footer">
      <div className="hazard-tape h-3" />
      <div className="petri m-3 p-8 text-center flex flex-col items-center gap-4">
        <img src={MASCOT_IMG} alt="Cyclospora mascot" className="w-20 h-20 wobble" />
        <h3 className="stencil text-3xl md:text-4xl">$CYCLOSPORA</h3>
        <p className="stencil-pink text-2xl md:text-3xl">wash your hands. it won't help.</p>

        <div className="flex flex-wrap justify-center gap-3">
          <a href={BUY_URL} target="_blank" rel="noreferrer" data-testid="footer-buy-btn" className="btn-hazard bg-[#d9b3ff] text-[#0a133f] px-6 py-3">BUY ON PUMP.FUN</a>
          <a href={X_URL} target="_blank" rel="noreferrer" data-testid="footer-x-btn" className="btn-hazard bg-white text-[#0a133f] px-6 py-3">X COMMUNITY</a>
        </div>

        <p className="font-mono2 text-[10px] md:text-xs text-white/50 break-all max-w-lg">CA: {CONTRACT_ADDRESS}</p>

        <p className="font-mono2 text-[10px] text-white/40 max-w-2xl mt-2">
          $Cyclospora is a meme coin with no intrinsic value, no expectation of financial return, and absolutely no medical advice.
          It is also not a real vector for disease. Please do not lick doorknobs. This is parody. DYOR.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
